import { withStyles } from '@material-ui/core/styles';
import styles from './ClientConnectsProgressBar.styles';
import ClientConnectsProgressBar from './ClientConnectsProgressBar';

export default withStyles(styles)(ClientConnectsProgressBar);
